'use strict';
import React, { PureComponent } from 'react'
import SelectorFecha from './SelectorFecha';

class InputFecha extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            classContenedor,
            esPrimerPaso,
            fechaInput,
            mensajeError,
            titulo
        } = this.props;


        //ACTIONS
        const {
            validarInputFecha
        } = this.props;

        let classInputFecha = {className: "form-control form-control-tarjetas"}
        let classDisabled = {className: "form-control botonMenuProcesos--disabled ContabilizadorRecontabilizador__seccionFiltrosFechas--disabled"}

        return (
            <div className={classContenedor}>
                <div className={esPrimerPaso ? "disableDiv" : "" }>
                        <SelectorFecha
                            claseContainer={`ContabilizadorRecontabilizador__contenedorFechaContabilidad ContabilizadorRecontabilizador__seccionFiltrosFechas ContabilizadorRecontabilizador--floatLeft ContabilizadorRecontabilizador__fechaDesdeMargin ${esPrimerPaso ? "" : "ContabilizadorRecontabilizador__seccionFiltrosFechas--disabled"}`}
                            errorFormatoFecha={null}
                            fecha={fechaInput}
                            funcionValidarInput={validarInputFecha}
                            inputProps={esPrimerPaso ? classInputFecha : classDisabled}
                            maxToday={true}
                            titulo={titulo}
                        />
                    </div>


                {mensajeError ? 
                    <div>
                        <label className="error ContabilizadorRecontabilizador__errorFechaContabilidad">{mensajeError}</label>
                    </div>
                :
                    null
                }
            </div>
        );
    }
}

export default InputFecha;